import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import { useAdmin } from '../context/AdminContext';

// Pages
import Dashboard from '../pages/Dashboard';
import Products from '../pages/Products';
import AddProduct from '../pages/AddProduct';
import Orders from '../pages/Orders';
import OrderDetails from '../pages/OrderDetails';
import Customers from '../pages/Customers';
import Inventory from '../pages/Inventory';
import Analytics from '../pages/Analytics';
import Reviews from '../pages/Reviews';
import Categories from '../pages/Categories';
import Coupons from '../pages/Coupons';
import Banners from '../pages/Banners';
import ActivityLogs from '../pages/ActivityLogs';
import Settings from '../pages/Settings';
import AdminProfile from '../pages/AdminProfile';
import Notifications from '../pages/Notifications';
import Roles from '../pages/Roles';
import Delivery from '../pages/Delivery';
import CMS from '../pages/CMS';
import Reports from '../pages/Reports';
import Stores from '../pages/Stores';
import Refunds from '../pages/Refunds';
import PaymentHistory from '../pages/PaymentHistory';

const AdminRoutes = () => {
  const location = useLocation();
  const { loading, user } = useAdmin();

  const isAdmin = Boolean(user?.role && user.role !== 'customer');

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center px-4">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-[#E8B530] border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="mt-4 text-sm font-semibold text-[#1F2A44]/70">Checking admin access...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        
        {/* Products */}
        <Route path="products" element={<Products />} />
        <Route path="products/add" element={<AddProduct />} />
        <Route path="products/edit/:id" element={<AddProduct />} />
        <Route path="categories" element={<Categories />} />
        
        {/* Orders */}
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:id" element={<OrderDetails />} />
        <Route path="payments" element={<PaymentHistory />} />
        <Route path="refunds" element={<Refunds />} />
        <Route path="delivery" element={<Delivery />} />
        <Route path="stores" element={<Stores />} />
        
        {/* Customers & Reviews */}
        <Route path="customers" element={<Customers />} />
        <Route path="reviews" element={<Reviews />} />
        
        {/* Inventory */}
        <Route path="inventory" element={<Inventory />} />
        
        {/* Analytics & Reports */}
        <Route path="analytics" element={<Analytics />} />
        <Route path="reports" element={<Reports />} />
        
        {/* Management */}
        <Route path="coupons" element={<Coupons />} />
        <Route path="banners" element={<Banners />} />
        <Route path="cms" element={<CMS />} />
        <Route path="notifications" element={<Notifications />} />
        
        {/* System */}
        <Route path="roles" element={<Roles />} />
        <Route path="logs" element={<ActivityLogs />} />
        <Route path="settings" element={<Settings />} />
        
        {/* Admin */}
        <Route path="profile" element={<AdminProfile />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
